import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSearchParams, useLocation } from "react-router-dom";
import calculateTotalPrice from "../../../common/libs/caclulateTotalPrice";
import "react-responsive-modal/styles.css";

import ModalChange from "../../../common/Components/Change/ModalChange";
import carSummaryImg from "../../../common/images/car-summary.webp";

const BookingSummary = ({
  product,
  airports,
  cancellation,
  sms,
  vehicles,
}) => {
  const [params] = useSearchParams();
  const location = useLocation();
  const pathname = location.pathname;

  const getDeparture = params.get("departure");
  const getArrival = params.get("arrival");
  const getAirport = params.get("airport");

  const [airport, setAirport] = useState("");
  const [open, setOpen] = useState(false);

  const imageUrl = product?.company
    ? product?.company?.image
    : product.image;

  let price = product?.payment
    ? parseFloat(product?.payment?.amount) * vehicles.length
    : parseFloat(
      product?.pay_later_status
        ? product?.commission_price
        : product?.price
    ) * vehicles.length;

  const total = calculateTotalPrice(
    product,
    price,
    cancellation,
    sms
  );

  let airportsUpdate = [];

  if (airports?.length) {
    airports?.forEach((airport) =>
      airportsUpdate.push({
        label: airport?.name,
        value: airport?.code,
      })
    );
  }

  useEffect(() => {
    const findIndex = airportsUpdate.findIndex(
      (a) => a.value === getAirport
    );

    setAirport(airportsUpdate[findIndex]?.label || "");

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getAirport]);

  const breakDownItems =
    pathname !== "/payment"
      ? [
        {
          label: product?.pay_later_status
            ? "Pay Now Price"
            : "Quote Amount",

          value: `£${(
            product?.pay_later_status
              ? parseFloat(product?.commission_price ?? 0) +
              (parseFloat(product?.discount ?? 0) > 0
                ? parseFloat(product?.discount)
                : 0)
              : parseFloat(product?.price ?? 0) +
              (parseFloat(product?.discount ?? 0) > 0
                ? parseFloat(product?.discount)
                : 0)
          ).toFixed(2)}`,
        },

        {
          label: "Price",
          value: `£${parseFloat(price || 0).toFixed(2)}`,
        },

        ...(parseFloat(product?.discount || 0) > 0
          ? [
            {
              label: "Discount",
              value: `- £${product.discount}`,
            },
          ]
          : []),

        ...(product?.discount && product.commission_price > 0
          ? [
            {
              label: "Discounted Amount",
              value: `£${product.commission_price}`,
            },
          ]
          : []),

        {
          label: "Sms Charge",
          value: `£${(
            sms
              ? product?.payment
                ? parseFloat(
                  product?.payment?.sms_charges || 0
                )
                : parseFloat(product.sms_charges || 0)
              : 0
          ).toFixed(2)}`,
        },

        {
          label: "Cancellation",
          value: `£${(
            cancellation
              ? product?.payment
                ? parseFloat(
                  product?.payment
                    ?.cancellation_charges || 0
                )
                : parseFloat(
                  product.cancellation_charges || 0
                )
              : 0
          ).toFixed(2)}`,
        },

        {
          label: "Booking Fee",
          value: `£${parseFloat(
            product?.payment
              ? product?.payment?.admin_charges || 0
              : product.admin_charges || 0
          ).toFixed(2)}`,
        },
      ]
      : [
        {
          label:
            parseFloat(
              product?.payment?.commission_amount || 0
            ) > 0
              ? "Pay Now Price"
              : "Quote Amount",

          value: `£${(
            parseFloat(
              product?.payment?.commission_amount || 0
            ) > 0
              ? parseFloat(
                product?.payment?.commission_amount ?? 0
              ) +
              parseFloat(
                product?.payment?.extra_charges ?? 0
              )
              : parseFloat(
                product?.payment?.amount ?? 0
              ) +
              parseFloat(
                product?.payment?.extra_charges ?? 0
              )
          ).toFixed(2)}`,
        },

        {
          label: "Price",
          value: `£${parseFloat(price || 0).toFixed(2)}`,
        },

        ...(parseFloat(product?.payment?.discount || 0) >
          0
          ? [
            {
              label: "Discount",
              value: `- £${product?.payment
                ? product?.payment?.discount
                : product.discount
                }`,
            },
          ]
          : []),

        ...(parseFloat(product?.payment?.discount || 0) >
          0 &&
          parseFloat(
            product?.payment?.commission_amount || 0
          ) > 0
          ? [
            {
              label: "Discounted Amount",
              value: `£${(
                parseFloat(
                  product?.payment
                    ?.commission_amount ?? 0
                ) +
                parseFloat(
                  product?.payment?.extra_charges ??
                  0
                ) -
                parseFloat(
                  product?.payment?.discount ?? 0
                )
              ).toFixed(2)}`,
            },
          ]
          : []),

        {
          label: "Sms Charge",
          value: `£${(
            sms
              ? product?.payment
                ? parseFloat(
                  product?.payment?.sms_charges || 0
                )
                : parseFloat(product.sms_charges || 0)
              : 0
          ).toFixed(2)}`,
        },

        {
          label: "Cancellation",
          value: `£${(
            cancellation
              ? product?.payment
                ? parseFloat(
                  product?.payment
                    ?.cancellation_charges || 0
                )
                : parseFloat(
                  product.cancellation_charges || 0
                )
              : 0
          ).toFixed(2)}`,
        },

        {
          label: "Booking Fee",
          value: `£${parseFloat(
            product?.payment
              ? product?.payment?.admin_charges || 0
              : product.admin_charges || 0
          ).toFixed(2)}`,
        },
      ];

  return (
    <div className="w-full max-w-[420px] mx-auto flex flex-col gap-5 font-poppins">

      {/* Main Card */}
      <div className="overflow-hidden bg-white border shadow-md border-slate-200 rounded-2xl">

        {/* Change Button */}
        {pathname !== "/payment" && (
          <div className="flex justify-center px-5 py-3 border-b bg-white border-slate-200">
            <button
              onClick={() => setOpen(true)}
              className="flex items-center gap-1.5 text-[15px] font-black tracking-wider text-lightprimary"
            >
              <svg
                className="size-6"
                fill="none"
                stroke="currentColor"
                strokeWidth="3"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                />
              </svg>

              CHANGE
            </button>

            <ModalChange
              airports={airports}
              open={open}
              setOpen={setOpen}
              refer="/search"
            />
          </div>
        )}

        <div className="px-2 py-3 bg-[#FBFBFB]">

          {/* Booking Summary Badge */}
          <div className=" mb-2">
            <div className="px-10 py-2 text-md text-center font-bold tracking-wide   rounded-lg shadow-sm bg-[#F9FEBB] text-primary ">
              Booking Summary
            </div>
          </div>

          {/* Heading */}
          {imageUrl && (
            <div className=" w-full">
              <img
                src={imageUrl}
                alt="logo"
                className="w-full h-[200px] rounded-lg shadow-md object-fill"
              />
            </div>
          )}
          <div className="flex-1">
            <h2 className="text-[28px] leading-8 py-2 font-black text-lightprimary">
              {product?.company
                ? product?.company?.name
                : product.name}
            </h2>

            {/* Tags */}
            <div className="flex flex-wrap gap-2 mt-1">

              <span className="px-2.5 py-1 text-[14px] font-medium font-black tracking-wide text-white uppercase rounded bg-primary">
                {product?.company
                  ? product?.company?.type
                  : product.type}
              </span>


            </div>
          </div>





          {/* Details Table */}
          <div className="mt-5 overflow-hidden border rounded-xl border-slate-200 bg-slate-50">

            {[
              {
                label: "Travelling from",
                value: product?.company
                  ? product?.company?.airport?.name
                  : airport || getAirport,
              },

              {
                label: "Departure Date",
                value: product?.departure_date
                  ? moment(
                    product?.departure_date
                  ).format("ddd, DD MMM YYYY")
                  : moment(getDeparture).format(
                    "ddd, DD MMM YYYY"
                  ),
              },

              {
                label: "Departure Time",
                value: product?.departure_time
                  ? product?.departure_time.slice(0, -3)
                  : moment(getDeparture).format("HH:mm"),
              },

              {
                label: "Arrival Date",
                value: product?.arrival_date
                  ? moment(product?.arrival_date).format(
                    "ddd, DD MMM YYYY"
                  )
                  : moment(getArrival).format(
                    "ddd, DD MMM YYYY"
                  ),
              },

              {
                label: "Arrival Time",
                value: product?.arrival_time
                  ? product?.arrival_time.slice(0, -3)
                  : moment(getArrival).format("HH:mm"),
              },
            ].map((item, idx) => (
              <div
                key={idx}
                className={`flex items-center justify-between px-4 py-3 ${idx !== 4
                  ? "border-b border-slate-200"
                  : ""
                  }`}
              >
                <span className="text-[15px] font-semibold text-slate-500">
                  {item.label}
                </span>

                <span className="text-[15px] font-black text-lightprimary">
                  {item.value}
                </span>
              </div>
            ))}
          </div>

          {/* Pricing Table */}
          <div className="mt-5 overflow-hidden border rounded-xl border-slate-200 bg-slate-100">

            {breakDownItems.map((item, index) => (
              <div
                key={index}
                className={`flex items-center justify-between px-4 py-3 ${index !== breakDownItems.length - 1
                  ? "border-b border-slate-200"
                  : ""
                  }`}
              >
                <span className="text-[15px] font-semibold text-slate-500">
                  {item.label}
                </span>

                <span className="text-[15px] font-black text-lightprimary">
                  {item.value}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* Total Price */}
        <div className="flex items-center justify-between px-5 py-4 bg-[#0B3B2E]">

          <span className="text-sm font-bold tracking-wide text-white uppercase">
            Total Price
          </span>

          <span className="text-[30px] leading-none font-black text-[#F5FF63]">
            £
            {pathname === "/payment"
              ? parseFloat(
                product?.payment?.total_amount || 0
              ).toFixed(2)
              : parseFloat(total || 0).toFixed(2)}
          </span>
        </div>
      </div>

      {/* Travel Stress Free */}
      <div
        className="relative p-5 overflow-hidden shadow-md rounded-2xl bg-cover bg-center bg-slate-50"
        style={{ backgroundImage: `url(${carSummaryImg})` }}
      >
        {/* optional dark overlay for readability */}

        <div className="relative z-10">
          <h3 className="text-lg font-black text-lightprimary">
            Park with complete confidence
          </h3>

          <p className="mt-1 text-xs font-medium leading-relaxed text-slate-500 max-w-[240px]">
            Enjoy secure airport parking with professional valet service,
            real-time flight tracking, and 24/7 customer support from drop-off to return.
          </p>

          <div className="flex items-end justify-between mt-5">
            {/* Features */}
            <div className="space-y-3">
              {[
                "Secure Parking",
                "24/7 Support",
                "Live Flight Tracking",
                "Valet Service",
              ].map((item, idx) => (
                <div key={idx} className="flex items-center gap-2">
                  <svg
                    className="w-4 h-4 text-lightprimary"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="3"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M5 13l4 4L19 7"
                    />
                  </svg>

                  <span className="text-[15px] font-semibold text-lightprimary">
                    {item}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingSummary;